import { InfoModal } from './InfoModal';

function parseItems(unit) {
  const raw = unit?.confirmed_checklist || unit?.confirmed_checklist_json || [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw === 'string') {
    try {
      const p = JSON.parse(raw);
      return Array.isArray(p) ? p : [];
    } catch {
      return [];
    }
  }
  return [];
}

/**
 * Read-only inspection questions for a unit type. Edit only in Set Inspection List.
 */
export default function UnitInspectionListPopup({ unit, isOpen, onClose, onEdit }) {
  if (!unit) return null;
  const items = parseItems(unit);
  const title = [unit.unique_id, unit.unit_type || unit.name].filter(Boolean).join(' · ');

  return (
    <InfoModal title={title || 'Inspection list'} isOpen={isOpen} onClose={onClose}>
      <p className="text-xs text-gray-500">
        Same questions for every unit of this type. Change them in <strong>Set Inspection List</strong>{' '}
        (one place).
      </p>
      {items.length === 0 ? (
        <p className="text-sm text-gray-500">No questions set yet.</p>
      ) : (
        <ol className="space-y-2 list-decimal pl-4">
          {items.map((it, i) => (
            <li key={it.id || i} className="text-sm text-gray-800">
              {it.question || it.text || '—'}
            </li>
          ))}
        </ol>
      )}
      {typeof onEdit === 'function' && (
        <div className="pt-1">
          <button
            type="button"
            onClick={() => {
              onClose?.();
              onEdit(unit);
            }}
            className="px-3 py-1.5 rounded-lg bg-primary-600 text-white text-sm font-medium hover:bg-primary-700"
          >
            Edit list
          </button>
        </div>
      )}
    </InfoModal>
  );
}
